module.exports = __webpack_public_path__ + "img/shore-power-red.2f73a157.svg";